import { useState } from "react";
import Loader from "../../common/loader";
import NavBar from "../../common/navbar";
import { handleAuth, postRequestOptions, baseUrl } from "../../common/cookie";
import axios from "axios";

function UpdatePreviousPrices() {
  let [error, setError] = useState<any>({});
  let [errorText, setErrorText] = useState<any>("");
  let [request, setRequestStatus] = useState(false);

  async function handleSubmit(event: any) {
    event.preventDefault();
    setRequestStatus(true);

    const form: any = document.getElementById("update-previous-prices");
    const formData = new FormData(form);

    const rawDate = formData.get("collectionDate");
    if (rawDate && typeof rawDate === "string") {
      let formatted = rawDate.replace("T", " ").slice(0, 16);
      formData.set("collectionDate", formatted);
    }

    try {
      setError({});
      setErrorText("");
      let url = baseUrl + "update-previous-prices";
      let action: any = await axios.post(url, formData, postRequestOptions);
      handleAuth(action.status);

      if (action.data.error) {
        if (typeof action.data.error == "string") {
          setErrorText(action.data.error);
        } else {
          setError(action.data.error);
        }
        setRequestStatus(false);
      } else {
        setRequestStatus(false);
        window.alert("Success!");
      }
    } catch (error) {
      console.error("Error:", error);
      setRequestStatus(false);
    }
  }

  if (request) {
    return (
      <div>
        <NavBar />
        <Loader />
      </div>
    );
  }
  return (
    <div>
      <NavBar />
      <div className="title">
        <h1>Update Previous Prices</h1>
      </div>
      <div className="card-body card row xlsx-card">
        <form onSubmit={(event) => handleSubmit(event)} encType="multipart/form-data" id="update-previous-prices">
          <div>
            <h3>Select or Enter Collection Date</h3>
          </div>
          <input
            type="datetime-local"
            className="select-collection-date"
            name="collectionDate"
            required
          />
          <small>
            If the selected date doesn't exist, a new snapshot will be created.
          </small>
          <div>
            <h3>Select pricing sheet type</h3>
          </div>
          <select className="select-collection-date" name="collectionType">
            <option>MUFG</option>
            <option>Bloomberg</option>
          </select>
          <div>
            <h3>Input Bloomberg/MUFG Pricing Excel csv/xlsx file</h3>
          </div>
          <div className="drop-container">
            <input multiple={true} className="drop-box-input" placeholder="Upload or drop file" type="file" name="file" accept=".xlsx, .csv" required />
          </div>
          <button type="submit" className="btn upload-btn">
            Upload
          </button>
        </form>
      </div>


      {Object.keys(error).length > 0 && (
        <div style={{ marginTop: "16px", paddingLeft: "8px" }}>
          {Object.keys(error).map((ticker: any, index: number) => {
            let detail = error[ticker];
            return (
              <p key={index} className="error-text" style={{ margin: "2px 0" }}>
                {ticker} with location {detail.location || ""} did not update. Notional = {detail.notional ?? 0}
              </p>
            );
          })}
        </div>
      )}

      <h4 className="error-text">
        {errorText || ""}
      </h4>
    </div>
  );
}

export default UpdatePreviousPrices;
